/* Deterministic Indian-style number grouping that does NOT depend on the
   runtime's ICU/locale data — so a server render (Vercel Lambda) and the client
   (browser) produce BYTE-IDENTICAL strings. toLocaleString('en-IN') /
   Intl.NumberFormat depend on ICU and can diverge between runtimes, which
   surfaces as a React #425 hydration text mismatch. Use this for any number that
   is rendered server-side and hydrated. */
export function formatIndianNumber(value: number | string | null | undefined): string {
  const num = Math.round(Number(value) || 0)
  const neg = num < 0
  const s = Math.abs(num).toString()
  let grouped: string
  if (s.length <= 3) {
    grouped = s
  } else {
    const last3 = s.slice(-3)
    const rest = s.slice(0, -3)
    grouped = rest.replace(/\B(?=(\d{2})+(?!\d))/g, ',') + ',' + last3
  }
  return (neg ? '-' : '') + grouped
}

/* "13 Jun 2026" — the registration/added date, formatted ICU-INDEPENDENTLY so a
   server render (Vercel Lambda, UTC) and the client (browser, IST) produce a
   BYTE-IDENTICAL string (toLocaleDateString is ICU/locale-dependent and would
   risk a #425 mismatch). IST is a fixed UTC+5:30 offset (no DST), so we shift
   then read UTC parts against a fixed month table. */
const ADDED_MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
export function formatAddedDate(value: string | number | Date | null | undefined): string {
  if (!value) return ''
  const d = new Date(value)
  if (isNaN(d.getTime())) return ''
  const ist = new Date(d.getTime() + 5.5 * 60 * 60 * 1000)
  return `${ist.getUTCDate()} ${ADDED_MONTHS[ist.getUTCMonth()]} ${ist.getUTCFullYear()}`
}
